import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import EmpAdminForm from "./EmpAdminForm";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useTheme, useMediaQuery, styled } from "@mui/material";

const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
  maxHeight: "90vh",
  bgcolor: "#ffffff",
  boxShadow: 24,
  borderRadius: "20px",
  width: "90%",           // ancho adaptativo
  maxWidth: 500,          // limite para desktop
  padding: theme.spacing(2),
}));

export default function EmpAdminModal({ isEdit, empAdmin }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {isEdit ? (
        <Button
          onClick={handleOpen}
          color="warning"
          variant="contained"
          size="small"
          startIcon={<FuseSvgIcon size={20}>heroicons-solid:pencil-alt</FuseSvgIcon>}
        >
          Editar
        </Button>
      ) : (
        <Button
          onClick={handleOpen}
          variant="contained"
          color="info"
          size="small"
          startIcon={<FuseSvgIcon size={20}>heroicons-solid:plus</FuseSvgIcon>}
          sx={{ mb: 1 }}
        >
          Agregar
        </Button>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="emp-admin-modal-title"
        aria-describedby="emp-admin-modal-description"
      >
        <StyledBox>
          <EmpAdminForm
            isEdit={isEdit}
            empAdmin={empAdmin}
            handleClose={handleClose}
          />
        </StyledBox>
      </Modal>
    </div>
  );
}
